import { MIXIN_PAGE_SENDING_REQUEST } from '@/mixins/page/mixinPageSendingRequest'
import { goToPage } from '@/utils/router'
import { showAlertError } from '@/utils/store/alert'

export const MIXIN_PAGE_CREATE = {
  mixins: [MIXIN_PAGE_SENDING_REQUEST],
  data: () => ({
    routeNameDetailed: '',
    postDataHasFiles: false
  }),
  methods: {
    async sendPostRequest (data) {
      try {
        this.startSendingRequest()

        const response = this.postDataHasFiles ? await this.createItemAndPostFiles(data) : await this.createItem(data)

        if (this.routeNameDetailed) {
          const id = response?.data?.data?.id
          await goToPage(this.routeNameDetailed, { id })
        }
      } catch (e) {
        showAlertError(e)
      } finally {
        this.finishSendingRequest()
      }
    }
  }
}
